import { LogLevel } from "@azure/msal-browser";
// Browser check variables
// If you support IE, our recommendation is that you sign-in using Redirect APIs
// If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
// Config object to be passed to Msal on creation

let clientId = process.env.REACT_APP_CLIENT_ID;
let authority = process.env.REACT_APP_AUTHORITY;
let redirectUri = process.env.REACT_APP_REDIRECT_URI;
let postLogoutRedirectUri = process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI;
let refersh_token = process.env.REACT_APP_REFRESH_TOKEN;

export const msalConfig = {
    auth: {
        clientId: clientId,
        authority: authority,            
        redirectUri: redirectUri,
        postLogoutRedirectUri: postLogoutRedirectUri
        // production config 
        //  clientId: "25d01926-8e6a-4177-ba0a-9d9b9c9606bb",
        //  authority: "https://login.microsoftonline.com/e0793d39-0939-496d-b129-198edd916feb/",
        //  validateAuthority: false,
        //  redirectUri: "https://atci.lkm.accenture.com/",
        //  postLogoutRedirectUri: "https://atci.lkm.accenture.com/",
        //  navigateToLoginRequestUrl: false, // Only needed if you need to support the redirect flow in Firefox incognito
       //  staging config   
        //  clientId: "81806e5f-ef30-43b5-b66c-837586f8d9f8",
        //  authority: "https://login.microsoftonline.com/f3211d0e-125b-42c3-86db-322b19a65a22/", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
        //  redirectUri: "http://localhost:3000",
        //  redirectUri: "https://atci.lkm.accenture.com/",
         //  postLogoutRedirectUri: 'https://atci.lkm.accenture.com/LKMPORTAL'
      },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {	
                    return;	
                }
                switch (level) {	
                    case LogLevel.Error:	
                        console.error(message);	
                        return;	
                    case LogLevel.Info:	
                        console.info(message);	
                        return;	
                    case LogLevel.Verbose:	
                        console.debug(message);	
                        return;	
                    case LogLevel.Warning:	
                        console.warn(message);	
                        return;	
                    default:
                        return;
                }
            }
        }
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
    scopes: ["openid","profile","email","User.Read"]
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
export const fetchMsGraph = async (url, accessToken) => {
    const response = await fetch(url, {
    headers: {
    Authorization: `Bearer ${accessToken}`,
    },
    });
           
    return response.json();
    };
    export const AUTH_REQUESTS = {
      LOGIN: {
      scopes: ['openid', 'profile'],
      },
      EMAIL: {
      scopes: [],
      },
      REFRESH_TOKEN: {
      scopes: [refersh_token],
      },
      };